import styled, {css} from 'styled-components'

const Button = styled.button`
  display: inline-block;
  border-radius: 2px;
  padding: 0.5rem 0;
  margin: 0.5rem 1rem;
  width: 11rem;
  background: transparent;
  color: white;
  border: 2px solid #7289da;

    ${props => props.primary && css`
        background: #7289da;
        color: white;
    `}

    ${props => props.dangerous && css`
        background: #ff2929;
        border: 2px solid #ff2929;
        color: white;
    `}

    ${props => props.big && css`
        font-size: 1.5em;
    `}

`;

export default Button;
